import React, {useCallback, useState, useEffect, useRef} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import LocationAndHotelSearch from '../../../../../stories/components/hotels/SRP/Autosuggests/LocationAndHotelSearch/LocationAndHotelSearch';
import Sorting from '../../../../../stories/components/hotels/SRP/Sorting/Sorting';
import SrpTab from './../../../../../stories/components/hotels/Loadingpage/SrpTab/SrpTab';
import * as S from './NavigationHeader.styles';
import Tabs from './../../../../../stories/components/hotels/common/Tabs/Tabs';
import {
  BaseColumnWrap,
  CenteredDivWrap,
} from '../../../../../stories/components/CommonStyleUtils/dwebCommon.styles';
import {
  srpNavigationHeaderOpenCloseOffset,
  srpNavigationHeaderOpenCloseThreshold,
} from '../../../../config/app-config';
import scrollToTop from '../../../../../shared/utils/scrollToTop';

import {
  ISrpConfig,
  IUpdate_Srp_Config,
  UPDATE_SRP_CONFIG,
  IFilters,
  IUpdate_Filter,
  ISrpData,
} from '../../redux/types';
import {updateSrpConfigAction, resetFilterAction} from '../../redux/actions';
import {fetchSrpDataThunk} from '../../redux/thunks';
import {
  srpDataSelectorFn,
  srpConfigSelectorFn,
  staticFilterLocationsListSelector,
  overrankVhidSelectorFn,
} from '../../redux/selectors';
import {cityIdSelectorFn} from '@stencil/hotels-common-reducer/src/selectors';
import {getFilterCategoryForHermesDataList} from '../../utils/filter-utils';
import TabsIconSelector from '../../../../../shared/components/TabsIconSelector';
import QuickFilters from '../QuickFilters';

import {pushga} from 'ga-utils';
import {SrpGAEvents, SrpSortingGAMap} from '../../../../../shared/config/ga-config';
import {useNavigateForSearchWidget} from '../../../../hooks/useNavigateForSearchWidget';
// ! Should be refactored into NavigationHeaderUI and container
const NavigationHeader = () => {
  const srpData = useSelector(srpDataSelectorFn);
  const srpConfig = useSelector(srpConfigSelectorFn);
  const cityId = useSelector(cityIdSelectorFn);
  const overrankVhid = useSelector(overrankVhidSelectorFn);
  const {
    locationFilterCheckboxList: staticFilterLocationsList,
    staticLocationsNamesIdMap,
  } = useSelector(staticFilterLocationsListSelector);

  const dispatch = useDispatch();
  const {onSearch: onFilterChange} = useNavigateForSearchWidget();

  const [open, setOpen] = useState(true);
  const [overFlowVisible, setOverFlowVisible] = useState(true);
  const handleScroll = () => {
    if (!window) return;
    window.pageYOffset <= 10 && setOpen(true);
    window.pageYOffset > srpNavigationHeaderOpenCloseThreshold && open && setOpen(false);
  };

  var scrollTimer,
    lastScrollFireTime = 0;

  const [landmarkOrAreaSelected, setLandmarkOrAreaSelected] = useState(null);

  const {city_meta_info} = srpData as ISrpData;

  const openCloseTranstionTime = useRef(false);

  const openCloseWithTransitionTime = () => {
    openCloseTranstionTime.current = true;
    let timer = setTimeout(function() {
      timer = null;
      openCloseTranstionTime.current = false;
    }, 400);
    setOpen(state => !state);
  };

  useEffect(() => {
    window.addEventListener('scroll', scrollThrottle);

    return () => {
      window.removeEventListener('scroll', scrollThrottle);
    };
  }, []);

  let overFlowTimer;

  useEffect(() => {
    overFlowTimer = null;
    if (open)
      overFlowTimer = setTimeout(() => {
        overFlowTimer = null;
        open && setOverFlowVisible(true);
      }, 300);
    else setOverFlowVisible(false);
  }, [open]);

  const updateFilterCaller = useCallback(
    (actionData: IUpdate_Filter['actionData'] = {}, scrollToTopMost = false) => {
      if (scrollToTopMost) scrollToTop(0, false);
      else scrollToTop(srpNavigationHeaderOpenCloseOffset, false);

      // dispatch({type: UPDATE_FILTER, actionData});
      // if (callApi) dispatch(fetchSrpDataThunk());
      onFilterChange({newFilterData: actionData, resetAllData: false});
    },
    [dispatch],
  );

  const updateSrpConfigCaller = useCallback(
    (actionData: IUpdate_Srp_Config['actionData'], resetFilters = false) => {
      dispatch({type: UPDATE_SRP_CONFIG, actionData});
      if (resetFilters) {
        dispatch(resetFilterAction());
        updateFilterCaller();
      }
      // if(callApi)
      // dispatch(fetchSrpDataThunk());
    },
    [dispatch],
  );

  const updateSortingCaller = useCallback(
    (actionData: string) => {
      dispatch(updateSrpConfigAction({s: actionData} as ISrpConfig));
      dispatch(fetchSrpDataThunk());
      pushga({
        eventCategory: SrpGAEvents.hotelSortByClicked,
        eventAction: SrpSortingGAMap[actionData],
      });
    },
    [dispatch],
  );

  if (!city_meta_info) return null;

  const {filter: appliedFiltersInState, s: sortingValue} = srpConfig as ISrpConfig;

  const {qf: quickFilterList, flt: tabsList} = city_meta_info;

  const {
    tag: tabsInState,
    // qf: quickFilterInState,
    location_search: locationFilterState = [],
  } = appliedFiltersInState;

  const scrollThrottle = () => {
    var minScrollTime = 200;
    var now = new Date().getTime();

    if (!scrollTimer && !openCloseTranstionTime.current) {
      if (now - lastScrollFireTime > 3 * minScrollTime) {
        handleScroll(); // fire immediately on first scroll
        lastScrollFireTime = now;
      }
      scrollTimer = setTimeout(function() {
        scrollTimer = null;
        lastScrollFireTime = new Date().getTime();
        handleScroll();
      }, minScrollTime);
    }
  };

  const gaHandler = (action, val) => {
    pushga({
      eventCategory: SrpGAEvents.hotelSrpFilterClicked,
      eventAction: action,
      eventLabel: val,
    });
  };

  return (
    <>
      <BaseColumnWrap>
        <S.TabLocationSearchWrapper
          heightStyle={(open && '4.8rem') || '0'}
          overflow={(overFlowVisible && open && 'visible') || 'hidden'}
          marginStyle={(open && '1rem auto 0 auto') || '0 auto'}
        >
          {(tabsList && tabsList.length > 0 && (
            <Tabs
              quickFilterOpen={open}
              name="tabs"
              lookup={item => {
                if (!item || !item.fd) return;
                return item.fd.tag;
              }}
              data={tabsList}
              renderItem={
                (item, isItemChecked) => (
                  // (item.ic !== 'tGosafe' && (
                  <CenteredDivWrap>
                    <TabsIconSelector
                      name={item.ic || 'taHotels'}
                      height="2.2rem"
                      width="2.2rem"
                      isActive={isItemChecked}
                    />
                    <span>{item.n}</span>
                  </CenteredDivWrap>
                )
                // )) || (
                //   <S.TabItemWrapperSpan>
                //     <TabsIconSelector
                //       name={item.ic}
                //       height="5.2rem"
                //       width="8.3rem"
                //       isActive={isItemChecked}
                //     />
                //   </S.TabItemWrapperSpan>
                // )
              }
              actionHandler={(item, itemUnderAction, isSelected) => {
                if (item.length) {
                  if (!item[0].fd || Object.keys(item[0].fd).length === 0) {
                    const filterCategory = getFilterCategoryForHermesDataList(tabsList);
                    delete appliedFiltersInState[filterCategory];
                    // const arg = {};
                    // arg[filterCategory] = '';
                    updateFilterCaller(appliedFiltersInState, true);
                  } else {
                    updateFilterCaller(item[0].fd as IFilters, true);
                  }
                }
                gaHandler(itemUnderAction?.n, true);
              }}
              defaultState={[tabsInState].map(item => ({fd: {tag: item}}))}
              setFirstAsDefault={true}
            />
          )) || <SrpTab />}
        </S.TabLocationSearchWrapper>
        <S.QuickFiltersAndSortingOuterWrap>
          <S.QuickFiltersAndSortingWrapper>
            <S.QuickFiltersWrapper>
              {/* <TopLocationsDropDown /> */}
              <QuickFilters
                data={quickFilterList}
                updateFilterCaller={updateFilterCaller}
                appliedFiltersInState={appliedFiltersInState}
              />
            </S.QuickFiltersWrapper>
            <S.LocationAndSortByOuterWrap>
              <LocationAndHotelSearch
                cityId={cityId}
                landmarkOrAreaSelected={landmarkOrAreaSelected}
                overrankVhid={overrankVhid}
                gaHandler={gaHandler}
                onItemSelection={changes => {
                  if (changes?.selectedItem?.t === 'hotel') {
                    updateSrpConfigCaller({overriderankvhids: changes.selectedItem._id}, true);
                    gaHandler('LocationAndHotelSearch', changes?.selectedItem?.t);
                  }

                  if (
                    changes?.selectedItem?.t === 'area' ||
                    changes?.selectedItem?.t === 'landmark'
                  ) {
                    let updatedLocationSearchForStore = [...(locationFilterState || [])];

                    if (landmarkOrAreaSelected) {
                      // remove the previously applied landmark or area from redux store
                      updatedLocationSearchForStore = updatedLocationSearchForStore.filter(
                        locationFilter => locationFilter.loc_id !== landmarkOrAreaSelected.loc_id,
                      );
                    }

                    let incomingLocationObj = {};
                    if (changes.selectedItem._id) {
                      incomingLocationObj = {
                        loc_id: changes.selectedItem._id,
                        n: changes.selectedItem.n,
                        id_type: 'voy',
                      };
                    } else {
                      incomingLocationObj = {
                        loc_id:
                          changes.selectedItem &&
                          changes.selectedItem.xtr &&
                          changes.selectedItem.xtr.ggl_id
                            ? changes.selectedItem.xtr.ggl_id
                            : '',
                        n:
                          changes.selectedItem && changes.selectedItem.n
                            ? changes.selectedItem.n
                            : '',
                        id_type: 'ggl_id',
                      };
                    }

                    // set latest location / area filter item in local state
                    setLandmarkOrAreaSelected(incomingLocationObj);

                    updatedLocationSearchForStore = [
                      ...updatedLocationSearchForStore,
                      incomingLocationObj,
                    ];
                    updateFilterCaller({
                      location_search: updatedLocationSearchForStore,
                    });

                    gaHandler('LocationAndHotelSearch', changes?.selectedItem?.t);
                  }
                }}
                staticFilterLocationsList={staticFilterLocationsList}
                staticLocationsNamesIdMap={staticLocationsNamesIdMap}
                locationFilterState={locationFilterState}
                setLandmarkOrAreaSelected={setLandmarkOrAreaSelected}
                tabsInState={tabsInState}
                resetHotelSelection={() => updateSrpConfigCaller({overriderankvhids: ''})}
                updateFilterCaller={updateFilterCaller}
              />
              {(sortingValue && (
                <Sorting updateSortingCaller={updateSortingCaller} sortingValue={sortingValue} />
              )) ||
                null}
            </S.LocationAndSortByOuterWrap>
          </S.QuickFiltersAndSortingWrapper>
        </S.QuickFiltersAndSortingOuterWrap>
      </BaseColumnWrap>
      <S.RightDoubleArrowOuterWrap
        onClick={openCloseWithTransitionTime}
        backgroundStyle={(open && 'white') || '#d1e5ff'}
      >
        <S.RightDoubleArrowIconWrap
          transformStyle={(open && 'rotate(-90deg)') || 'rotate(90deg)'}
        />
      </S.RightDoubleArrowOuterWrap>
    </>
  );
};

export default NavigationHeader;
